import { useState } from 'react';

import ClickAwayListener from '@mui/material/ClickAwayListener';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import InfoIcon from '@mui/icons-material/Info';

const TooltipClick = ({ title }) => {
    const [open, setOpen] = useState(false);

    const handleTooltipClose = () => {
        setOpen(false);
    };

    const handleTooltipOpen = () => {
        setOpen(true);
    };

    return (
        <ClickAwayListener onClickAway={handleTooltipClose}>
            <Tooltip
                title={title}
                open={open}
                disableFocusListener
                disableHoverListener
                disableTouchListener
                slotProps={{
                    popper: {
                        disablePortal: true,
                    },
                }}
            >
                <IconButton sx={{ fontSize: "smaller" }} onClick={handleTooltipOpen}>
                    <InfoIcon fontSize="inherit" />
                </IconButton>
            </Tooltip>
        </ClickAwayListener>
    );
}

export default TooltipClick;